import request from '@/axios'
import type { UserType } from './types'

interface RoleParams {
  roleName: string
}

export const loginApi = (data: UserType): Promise<IResponse<UserType>> => {
  return request.post({ url: '/mock/user/login', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/mock/user/loginOut' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/mock/role/list', params })
}

export const getUserRoleApi = () => {
  return request.get({ url: '/auth/menu' })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}

// newLogin
export const getNewLoginApi = (data: any) => {
  return request.post({ url: '/auth/login', data })
}

// 获取验证码
export const getCodeApi = (data: {
  phone: string
  checkAuthKey: string
  receiverType: string
  username?: string
}) => {
  return request.get({ url: '/auth/getPhoneCode', params: data })
}

/** 后台 Web 登录配置（展示短信区 / 强制校验验证码可分别配置） */
export const getWebLoginConfigApi = () => {
  return request.get<{ smsEnabled: boolean; smsRequired: boolean }>({ url: '/auth/webLoginConfig' })
}

// 单点登录获取token
export const getSSOTokenApi = (data: any) => {
  return request.get({ url: '/auth/ztj/getToken', params: data })
}
